module.exports = __webpack_public_path__ + "img/picaflor.f1149475.png";